import type { ConversationCompactionKind } from "@shaarp/common";

/**
 * Translation keys for the three kinds of compaction.
 *
 * They are not interchangeable, and lumping them under one word is what makes
 * "the assistant forgot" unexplainable: only a boundary actually ends the
 * history. Keys rather than text, so this module stays free of React.
 */
export const compactionKindLabelKey = (
  kind: ConversationCompactionKind
): string => `chat.debug.compaction.kinds.${kind}.label`;

export const compactionKindHintKey = (
  kind: ConversationCompactionKind
): string => `chat.debug.compaction.kinds.${kind}.hint`;

export const COMPACTION_KIND_VARIANTS: Record<
  ConversationCompactionKind,
  "secondary" | "warning" | "destructive"
> = {
  "structural-prune": "secondary",
  "llm-summary": "warning",
  boundary: "destructive",
};

/** Which kind the tier recorded on a single turn corresponds to, 0 meaning none. */
export const turnCompactionKind = (
  tier: 0 | 1 | 2
): ConversationCompactionKind | null =>
  tier === 0 ? null : tier === 1 ? "structural-prune" : "llm-summary";

export const turnCompactionVariant = (
  tier: 0 | 1 | 2
): "success" | "secondary" | "warning" =>
  tier === 0 ? "success" : tier === 1 ? "secondary" : "warning";
